// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1":"673013a32615ca9a356c","311":"7c69f7a7064bdce547e3","826":"14f4399e8ecfcfab65bd"}[chunkId] + ".chunk.min.js";
};